@if (pageData().componentId && pageData().mode) {
  @if (mode() === 'desktop') {
    <!-- Desktop layout -->
    <div
      class="sia-actions-container flex min-h-[48px] min-w-0 flex-nowrap items-center justify-end gap-2 overflow-hidden hardware-accelerate"
      #desktopContainer
    >
      @for (action of inlineActions(); track action.id || $index) {
        <div class="flex min-w-0 shrink-0 items-center">
          <ng-template
            [ngTemplateOutlet]="drawAction"
            [ngTemplateOutletContext]="{ action: action, inline: true }"
          >
          </ng-template>
        </div>
      }

      <!-- Overflow menu per azioni compattate gradualmente -->
      @if (overflowActions().length > 0) {
        <button
          mat-icon-button
          class="primary shrink-0"
          [class]="'stroked ' + buttonsSize()"
          [matMenuTriggerFor]="overflowMenu"
          [siaTooltip]="'Azioni Raggruppate'"
          [disableMobile]="true"
          data-overflow-trigger="true"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
      }

      <!-- Gruppi always-grouped -->
      @for (group of groups(); track group.id) {
        @if (group.alwaysGrouped) {
          @if (onlyIcons() || overflowActions().length > 0) {
            <button
              mat-icon-button
              [class]="buttonsSize()"
              class="action-icon-button primary"
              [matMenuTriggerFor]="actionsMenu"
              [matMenuTriggerData]="{ actions: groupsActions()[group.id] }"
            >
              <mat-icon>{{ group.icon }}</mat-icon>
            </button>
          } @else {
            <button
              mat-stroked-button
              [class]="buttonsSize()"
              [matMenuTriggerFor]="actionsMenu"
              [matMenuTriggerData]="{ actions: groupsActions()[group.id] }"
            >
              <mat-icon>{{ group.icon }}</mat-icon>
              {{ group.name | siaTranslate }}
            </button>
          }
        }
      }

      <!-- Non-always-grouped groups (solo quando ci sono azioni compattate) -->
      @for (group of groups(); track group.id) {
        @if (!group.alwaysGrouped) {
          <button
            mat-icon-button
            class="primary"
            [class]="'stroked ' + buttonsSize()"
            [matMenuTriggerFor]="actionsMenu"
            [matMenuTriggerData]="{ actions: groupsActions()[group.id] }"
            [siaTooltip]="group.name"
            [disableMobile]="true"
          >
            <mat-icon>{{ group.icon }}</mat-icon>
          </button>
        }
      }

      @if (isAdmin()) {
        <button
          mat-icon-button
          class="primary"
          [class]="'stroked ' + buttonsSize()"
          (click)="navigateToConfigurator()"
          (contextmenu)="onAdminContextMenu($event)"
          [siaTooltip]="'Configuratore'"
          [disableMobile]="true"
          [class.error]="isDelta() ? false : hasCustomerConfig()"
          [class.tertiary]="isDelta()"
        >
          <mat-icon>settings</mat-icon>
        </button>
      }
    </div>

    <!-- Hidden measurer: rendered but not visible, used only for offsetWidth -->
    <div #measureContainer class="sia-actions-measure" aria-hidden="true">
      @for (action of allInlineActionsForMeasure(); track action.id) {
        <div
          class="flex min-w-0 shrink-0 items-center"
          [attr.data-measure-key]="action.id"
        >
          <ng-template
            [ngTemplateOutlet]="drawAction"
            [ngTemplateOutletContext]="{
              action: action,
              inline: true,
              measure: true,
            }"
          >
          </ng-template>
        </div>
      }

      <button
        mat-icon-button
        class="primary shrink-0"
        [class.stroked]="buttonsSize()"
        data-measure-overflow="true"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>

    <!-- Overflow menu -->
    <mat-menu #overflowMenu="matMenu">
      <ng-template matMenuContent>
        @for (action of overflowActions(); track $index) {
          @if (action.style === 'list') {
            <button
              [id]="(pageData().componentId ?? '') + action.id"
              mat-menu-item
              [matMenuTriggerFor]="emptyMenu"
              #actionTrigger="matMenuTrigger"
              (mouseenter)="fireAction(action, actionTrigger)"
              (click)="fireAction(action, actionTrigger)"
              [disabled]="action.disabled"
            >
              <div class="flex w-full items-center gap-2">
                <mat-icon
                  [matBadge]="1"
                  class="badge-primary badge-no-text"
                  [matBadgeHidden]="!action.showBadge"
                  matBadgeSize="medium"
                  matBadgePosition="before"
                  >{{ action.icon }}</mat-icon
                >
                @if (action.name) {
                  <span>{{ action.name | siaTranslate }}</span>
                }
              </div>
            </button>
          } @else if (action.style === 'template') {
            <div mat-menu-item>
              <ng-container
                *ngTemplateOutlet="action.template || default"
              ></ng-container>
            </div>
          } @else {
            <button
              [id]="(pageData().componentId ?? '') + action.id"
              mat-menu-item
              (click)="fireAction(action)"
              [disabled]="action.disabled"
            >
              <div class="flex w-full items-center gap-2">
                <mat-icon
                  [matBadge]="1"
                  class="badge-primary badge-no-text"
                  [matBadgeHidden]="!action.showBadge"
                  matBadgeSize="medium"
                  matBadgePosition="before"
                  >{{ action.icon }}</mat-icon
                >
                @if (action.name) {
                  <span>{{ action.name | siaTranslate }}</span>
                }
              </div>
            </button>
          }
        }
      </ng-template>
    </mat-menu>
  } @else {
    <!-- Mobile layout -->
    <div
      class="container-safe-height flex w-full flex-row justify-between p-1"
      #actionContainerMobile
      id="actionContainerMobile"
    >
      @for (action of leftActions(); track action; let index = $index) {
        <ng-container
          [ngTemplateOutlet]="mobileActionTemplate"
          [ngTemplateOutletContext]="{ action: action }"
        ></ng-container>
      }
      @if (nonStaticActions().length > 0) {
        <div class="flex w-[calc(100%/5)] justify-center">
          <button
            mat-fab
            #moreActionsButton
            class="secondary mat-fab-mobile-container w-[calc(100%/5)]"
            (click)="openActionSheet()"
          >
            <mat-icon> apps </mat-icon>
          </button>
        </div>
      } @else {
        <div class="w-[calc(100%/5)]"></div>
      }
      @for (action of rightActions(); track action; let index = $index) {
        <ng-container
          [ngTemplateOutlet]="mobileActionTemplate"
          [ngTemplateOutletContext]="{ action: action }"
        ></ng-container>
      }

      @if (pageData().mode === 'read') {
        @if (showBackAction()) {
          @if (staticActions().length > 0 && staticActions().length % 2 === 0) {
            <div class="flex w-[calc(100%/5)] justify-center"></div>
          }
          <button
            mat-button
            class="button-column button-surface w-[calc(100%/5)]"
            (click)="navigateBackAction()"
          >
            <mat-icon> arrow_back </mat-icon>
            {{ 'Indietro' | siaTranslate }}
          </button>
        }
      }
    </div>

    <!-- Mobile action template -->
    <ng-template #mobileActionTemplate let-action="action">
      @if (action.id) {
        @if (action.style === 'template') {
          <div class="flex w-[calc(100%/5)] justify-center">
            <ng-container
              *ngTemplateOutlet="action.template || default"
            ></ng-container>
          </div>
        } @else {
          <button
            (click)="fireAction(action)"
            mat-button
            class="button-column button-surface badge-primary badge-no-text w-[calc(100%/5)]"
            [matBadge]="1"
            [matBadgeHidden]="!action.showBadge"
            matBadgeSize="medium"
            matBadgePosition="before"
          >
            <mat-icon> {{ action.icon }} </mat-icon>
            {{ action.name | siaTranslate }}
          </button>
        }
      } @else {
        <div class="w-[calc(100%/5)]"></div>
      }
    </ng-template>
  }
}

<!-- Shared menus -->
<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-actions="actions">
    @for (action of actions; track $index) {
      @if (action.style === 'list') {
        <button
          [id]="(pageData().componentId ?? '') + action.id"
          mat-menu-item
          [matMenuTriggerFor]="emptyMenu"
          #actionTrigger="matMenuTrigger"
          (mouseenter)="fireAction(action, actionTrigger)"
          (click)="fireAction(action, actionTrigger)"
          [disabled]="action.disabled"
        >
          <div class="flex w-full items-center gap-2">
            <mat-icon
              [matBadge]="1"
              class="badge-primary badge-no-text"
              [matBadgeHidden]="!action.showBadge"
              matBadgeSize="medium"
              matBadgePosition="before"
              >{{ action.icon }}</mat-icon
            >
            @if (action.name) {
              <span>{{ action.name | siaTranslate }}</span>
            }
          </div>
        </button>
      } @else if (action.style === 'template') {
        <div mat-menu-item>
          <ng-container
            *ngTemplateOutlet="action.template || default"
          ></ng-container>
        </div>
      } @else {
        <button
          [id]="(pageData().componentId ?? '') + action.id"
          mat-menu-item
          (click)="fireAction(action)"
          [disabled]="action.disabled"
        >
          <div class="flex w-full items-center gap-2">
            <mat-icon
              [matBadge]="1"
              class="badge-primary badge-no-text"
              [matBadgeHidden]="!action.showBadge"
              matBadgeSize="medium"
              matBadgePosition="before"
              >{{ action.icon }}</mat-icon
            >
            @if (action.name) {
              <span>{{ action.name | siaTranslate }}</span>
            }
          </div>
        </button>
      }
    }
  </ng-template>
</mat-menu>

<mat-menu #emptyMenu="matMenu">
  <ng-template matMenuContent> </ng-template>
</mat-menu>

<ng-template #default></ng-template>

<!-- Admin context menu trigger (invisible, positioned at mouse click) -->
<div
  class="admin-context-trigger"
  [style.left.px]="adminContextMenuX"
  [style.top.px]="adminContextMenuY"
  [matMenuTriggerFor]="adminContextMenu"
  #adminContextTrigger="matMenuTrigger"
></div>

<mat-menu
  #adminContextMenu="matMenu"
  class="admin-info-context-menu min-w-fit !max-w-none"
>
  <ng-template matMenuContent>
    @let info = componentInfo();
    @if (info) {
      <div
        class="flex min-w-fit flex-col gap-2 px-4 py-3"
        (click)="$event.stopPropagation()"
      >
        @if (info.id) {
          <div class="flex w-full flex-row justify-between gap-2">
            <span class="text-outline font-semibold"
              >{{ 'ID' | siaTranslate }}:</span
            >
            <span class="">{{ info.id }}</span>
          </div>
        }
        @if (info.dataType) {
          <div class="flex w-full flex-row justify-between gap-2">
            <span class="text-outline font-semibold"
              >{{ 'Modulo' | siaTranslate }}:</span
            >
            <span class="">{{ info.dataType }}</span>
          </div>
        }
        @if (info.tableName) {
          <div class="flex w-full flex-row justify-between gap-2">
            <span class="text-outline font-semibold"
              >{{ 'Tabella' | siaTranslate }}:</span
            >
            <span class="">
              {{ info.tableSchema ? info.tableSchema + '.' : '' }}
              {{ info.tableName }}
            </span>
          </div>
        }
        @if (info.viewName) {
          <div class="flex w-full flex-row justify-between gap-2">
            <span class="text-outline font-semibold"
              >{{ 'Vista' | siaTranslate }}:</span
            >
            <span class="">
              {{ info.viewSchema ? info.viewSchema + '.' : '' }}
              {{ info.viewName }}
            </span>
          </div>
        }
      </div>
    } @else {
      <div mat-menu-item disabled>
        <span class="text-sm opacity-70">Nessuna informazione disponibile</span>
      </div>
    }
  </ng-template>
</mat-menu>

<!-- Desktop draw action template -->
<ng-template
  #drawAction
  let-action="action"
  let-inline="inline"
  let-measure="measure"
>
  @if (!onlyIcons()) {
    @switch (action.style) {
      @case ('flat') {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [disabled]="action.disabled"
          mat-flat-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          [class.w-full]="!inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
        >
          <div
            class="flex w-full items-center justify-center gap-2"
            [class.w-auto]="inline"
          >
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
            @if (action.name) {
              <span class="whitespace-nowrap">{{
                action.name | siaTranslate
              }}</span>
            }
          </div>
        </button>
      }
      @case ('stroked-error') {
        <button
          [disabled]="action.disabled"
          mat-stroked-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          [class.w-full]="!inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text error"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
        >
          <div
            class="flex w-full items-center justify-center gap-2"
            [class.w-auto]="inline"
          >
            <mat-icon class="badge-primary badge-no-text">{{
              action.icon
            }}</mat-icon>
            @if (action.name) {
              <span class="whitespace-nowrap">{{
                action.name | siaTranslate
              }}</span>
            }
          </div>
        </button>
      }
      @case ('list') {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          [class.w-full]="!inline"
          [disabled]="action.disabled"
          mat-stroked-button
          [matMenuTriggerFor]="emptyMenu"
          #actionTrigger="matMenuTrigger"
          (click)="fireAction(action, actionTrigger)"
          [matBadge]="1"
          class="badge-primary badge-no-text"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
        >
          <div
            class="flex w-full items-center justify-center gap-2"
            [class.w-auto]="inline"
          >
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
            @if (action.name) {
              <span class="whitespace-nowrap">{{
                action.name | siaTranslate
              }}</span>
            }
          </div>
        </button>
      }
      @case ('template') {
        <ng-container
          *ngTemplateOutlet="action.template || default"
        ></ng-container>
      }
      @default {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [disabled]="action.disabled"
          mat-stroked-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          [class.w-full]="!inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
        >
          <div
            class="flex w-full items-center justify-center gap-2"
            [class.w-auto]="inline"
          >
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
            @if (action.name) {
              <span class="whitespace-nowrap">{{
                action.name | siaTranslate
              }}</span>
            }
          </div>
        </button>
      }
    }
  } @else {
    @switch (action.style) {
      @case ('flat') {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [disabled]="action.disabled"
          mat-icon-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text action-icon-button"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
          [siaTooltip]="action.name ?? action.description"
          [disableMobile]="true"
        >
          <div class="flex w-full items-center justify-center gap-2">
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
          </div>
        </button>
      }
      @case ('stroked-error') {
        <button
          [disabled]="action.disabled"
          mat-icon-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text error action-icon-button"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
          [siaTooltip]="action.name ?? action.description"
          [disableMobile]="true"
        >
          <mat-icon class="badge-primary badge-no-text">{{
            action.icon
          }}</mat-icon>
        </button>
      }
      @case ('list') {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          [disabled]="action.disabled"
          mat-icon-button
          [matMenuTriggerFor]="emptyMenu"
          #actionTrigger="matMenuTrigger"
          (click)="fireAction(action, actionTrigger)"
          [matBadge]="1"
          class="badge-primary badge-no-text action-icon-button"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
          [siaTooltip]="action.name ?? action.description"
          [disableMobile]="true"
        >
          <div class="flex w-full items-center justify-center gap-2">
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
          </div>
        </button>
      }
      @case ('template') {
        <ng-container
          *ngTemplateOutlet="action.template || default"
        ></ng-container>
      }
      @default {
        <button
          [attr.id]="
            measure ? null : (pageData().componentId ?? '') + action.id
          "
          [disabled]="action.disabled"
          mat-icon-button
          [class]="buttonsSize()"
          [class.shrink-0]="inline"
          (click)="fireAction(action)"
          [matBadge]="1"
          class="badge-primary badge-no-text action-icon-button"
          [matBadgeHidden]="!action.showBadge"
          matBadgeSize="medium"
          matBadgePosition="before"
          [siaTooltip]="action.name ?? action.description"
          [disableMobile]="true"
        >
          <div class="flex w-full items-center justify-center gap-2">
            <mat-icon class="badge-primary badge-no-text">
              {{ action.icon }}
            </mat-icon>
          </div>
        </button>
      }
    }
  }
</ng-template>
